import server from '../server'


export default {
  data() {
    return {
      loading: false,
      success: null,
      error: null,
      username: ''
    }
  },

  methods:{
    recover(){
      if(!this.username) return
      this.loading = true
      this.invalid = false

      server.recover(this.username)
      .then(result => {
        this.loading = false
        this.success = result.success        
      })
      .catch(error => {
        this.loading = false
        this.error = error
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/recover/mixins/recover.js